import http from 'http'
import { isEmpty, pick } from 'ramda'

export const getHeaders = (
  req?: http.IncomingMessage
): { headers?: Record<string, string> } => {
  if (!req || isEmpty(req)) return {}
  const forwarded = req.headers['x-forwarded-for']
  const ip = forwarded
    ? Array.isArray(forwarded)
      ? forwarded[0]
      : forwarded.split(/, /)[0]
    : req.socket.remoteAddress || ''
  return {
    headers: {
      'x-forwarded-for': ip,
      ...pick(['cookie', 'user-agent', 'pragma'], req.headers)
    }
  }
}

export function toFormData(
  obj: object,
  formData = new FormData(),
  parentKey = ''
) {
  if (obj === null || obj === undefined) {
    return formData
  }

  if (obj instanceof Date) {
    formData.append(parentKey, obj.toISOString())
  } else if (obj instanceof File) {
    formData.append(parentKey, obj, obj.name)
  } else if (Array.isArray(obj) || obj instanceof FileList) {
    for (let i = 0; i < obj.length; i++) {
      toFormData(obj[i], formData, `${parentKey}[${i}]`)
    }
  } else if (typeof obj === 'object' && !(obj instanceof Blob)) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key
        toFormData(obj[key as keyof typeof obj], formData, fullKey)
      }
    }
  } else {
    formData.append(parentKey, obj)
  }

  return formData
}
